import React, { PureComponent } from 'react';

class MotivoAjuste extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {

        const { ingresoAjuste, seleccionarMotivo, permisos, form } = this.props;
        const { motivoAjusteData, motivoAjusteId, ajusteEdicion, motivoAjusteEdicion } = ingresoAjuste;
        let permisoDeAlta = permisos && permisos.Alta ? false : true; 
        
        let titulo = ingresoAjuste.ajusteCargoRdButton ? "Concepto de cargo *" : "Motivo de ajuste *";

        let ajusteMotivos = undefined;
        let ajusteMotivosEdicion = undefined;
        let esMotivoActivo = true;
        let ajusteMotivosFiltrados = undefined;

        ajusteMotivosFiltrados = motivoAjusteData.filter((ajuste) => ajuste.Activo);

        ajusteMotivos = ajusteMotivosFiltrados.map((ajuste, index) => {
            return (
                <option key={"ajuste-opt" + index} value={ajuste.IdMotivo}>
                    {ajuste.Descripcion}
                </option>
            );
        });
         
        let errorAjusteCargoSelect = ingresoAjuste && ingresoAjuste.errorAjusteCargoSelect ? 
                                            <label className="error">Seleccione una opción</label> 
                                        :
                                            null;

        if (ajusteEdicion) {
            titulo = ajusteEdicion.TipoMovimiento == "A" ? "Motivo de ajuste" : "Concepto de cargo";

            esMotivoActivo = motivoAjusteData.filter(ajuste => ajuste.Id == motivoAjusteEdicion[0].IdMotivo && ajuste.Activo == 1).length > 0;

            if (!esMotivoActivo) {
                ajusteMotivosEdicion = 
                    <option key={"ajuste-opt" + motivoAjusteEdicion[0].IdMotivo} value={motivoAjusteEdicion[0].IdMotivo}>
                        {motivoAjusteEdicion[0].Descripcion}
                    </option>
            }
        }

        return ( 
            <div className="row top-separator-xs">
                <div className="selectAjusteCargo">
                    <label className="label-primary">{titulo}</label>
                    <select
                        disabled={permisoDeAlta}
                        value={motivoAjusteId == 0 && ajusteEdicion ? motivoAjusteEdicion[0].IdMotivo : motivoAjusteId}
                        className="form-control default-select"
                        onChange={(event) => {
                            seleccionarMotivo(parseInt(event.target.value),form.resetFields)
                        }}
                    >
                        <option value="0">Seleccione...</option>
                        {!esMotivoActivo && ajusteMotivosEdicion}
                        {ajusteMotivos}
                    </select>
                    {errorAjusteCargoSelect}
                </div>
            </div>                
        );
    }
}

export default MotivoAjuste;
